import makeStyles from '@material-ui/core/styles/makeStyles';
import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

interface IProps extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {}

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    overflow: 'hidden',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  backdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    '&:first-of-type': {
      filter: 'blur(6px)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    },
  },
  image: {
    position: 'absolute',
    margin: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 2,
    objectFit: 'cover',
  },
}));

const Image = (props: IProps) => {
  const classes = useStyles();

  if (props.src === null) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={classes.backdrop} style={{ backgroundImage: `url(${props.src})` }} />
      <img className={classes.image} alt={props.alt} {...props} />
    </div>
  );
};

export default Image;
